var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 29.7467C29.3994 29.7467 33.7474 28.541 34.1673 23.7015C34.1673 18.8653 31.1359 19.1763 31.1359 13.2425C31.1359 8.60755 26.7427 3.33398 20.0007 3.33398C13.2586 3.33398 8.8654 8.60755 8.8654 13.2425C8.8654 19.1763 5.83398 18.8653 5.83398 23.7015C6.25557 28.5593 10.6036 29.7467 20.0007 29.7467Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9827 34.7617C21.7092 37.2862 18.1625 37.3162 15.8672 34.7617",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notificationBell.e56355cf14e4096203bf0b341bd17308.svg";
export { ForwardRef as ReactComponent };